import * as transSummaryByLevel3Actions from '../actions/trans-summary-by-level3.actions';

export interface TransSummaryByLevel3State {
  transSummaryByLevel3: any;
  loading: boolean;
  loaded: boolean;
}

const initialState = {
  transSummaryByLevel3: null,
  loading: false,
  loaded: false
};

export const transSummaryByLevel3Reducer = (state = initialState, action) => {
  switch (action.type) {
    case transSummaryByLevel3Actions.GET_TRANS_SUMMARY_BY_LEVEL3_LIST:
      return {
        ...state,
        loading: true,
        loaded: state.loaded
      };
    case transSummaryByLevel3Actions.GET_TRANS_SUMMARY_BY_LEVEL3_LIST_SUCCESS:
      return {
        ...state,
        transSummaryByLevel3: action.payload,
        loading: false,
        loaded: true,
      };
    case transSummaryByLevel3Actions.GET_TRANS_SUMMARY_BY_LEVEL3_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
        loaded: false
      };
    case transSummaryByLevel3Actions.CLEAR_TRANS_SUMMARY_BY_LEVEL3_LIST:
      return {
        ...state,
        error: null,
        transSummaryByLevel3: null,
        loading: false,
        loaded: false
      };
    default:
      return state;
  }
};

export const getTransSummaryByLevel3List = (state: TransSummaryByLevel3State) => state.transSummaryByLevel3;
export const getTransSummaryByLevel3ListLoaded = (state: TransSummaryByLevel3State) => state.loaded;
